import { render, staticRenderFns } from "./ModuleMap.vue?vue&type=template&id=538df9ea&scoped=true&"
import script from "./ModuleMap.vue?vue&type=script&lang=js&"
export * from "./ModuleMap.vue?vue&type=script&lang=js&"
import style0 from "./ModuleMap.vue?vue&type=style&index=0&id=538df9ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538df9ea",
  null
  
)

export default component.exports